// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__dQ2le","col":"Table_col__3yKcq","fulfillmentStatus":"Table_fulfillmentStatus__1yEft","emailCol":"Table_emailCol__22SNi"};